export default "__VITE_ASSET__CqdrvJjU__"